import { CheckCircle2 } from "lucide-react";
import { COMPANY } from "@/data/products";

const COMMITMENTS = [
  { title: "Clear information", text: "Product names, categories and prices presented plainly, so you know exactly what is offered." },
  { title: "Helpful communication", text: "Reach us easily by email or WhatsApp — we are glad to answer product and order questions." },
  { title: "Professional relationships", text: "We welcome enquiries from customers and suppliers alike, and aim to build dependable, long-term relationships." },
];

export default function About() {
  return (
    <section id="about" className="py-20 md:py-28 bg-white" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <p className="text-[#0d7a72] text-sm font-bold tracking-[0.25em] uppercase mb-3">About Us</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold text-[#10233f] mb-6" data-testid="about-heading">
            A Malaysian retailer for gaming, collectibles and hobby products
          </h2>
          <p className="text-base text-[#5a6b85] leading-relaxed mb-8" data-testid="about-intro">
            {COMPANY.legalName} is a Malaysian retailer based in Sungai Petani, Kedah, focused on
            EDC toys, games, collectibles, video game consoles and hobby products. We welcome
            enquiries from customers and from suppliers interested in working with us.
          </p>

          <div className="space-y-6 mb-10">
            <div className="border-l-2 border-[#0d7a72] pl-5" data-testid="about-mission">
              <h3 className="font-bold text-[#10233f] mb-1">Our Mission</h3>
              <p className="text-sm text-[#5a6b85] leading-relaxed">
                Help customers explore gaming, collectibles and hobby products through clear
                information and helpful communication.
              </p>
            </div>
            <div className="border-l-2 border-[#0d7a72] pl-5" data-testid="about-vision">
              <h3 className="font-bold text-[#10233f] mb-1">Our Vision</h3>
              <p className="text-sm text-[#5a6b85] leading-relaxed">
                Develop a dependable retail presence connecting customers with products suited to
                their interests.
              </p>
            </div>
          </div>

          <p className="text-xs text-[#8a97ad]" data-testid="about-legal">
            {COMPANY.legalName} · SSM Registration No. {COMPANY.ssm}
          </p>
        </div>

        <div>
          <div className="rounded-3xl overflow-hidden shadow-2xl aspect-[4/3] bg-[#071630]" data-testid="about-image">
            <img
              src="/assets/hero-editorial.png"
              alt="Hobby and collectible products still-life"
              className="w-full h-full object-cover object-[70%_center]"
            />
          </div>
          <div className="mt-8 space-y-4">
            {COMMITMENTS.map((c) => (
              <div key={c.title} className="flex gap-3" data-testid={`about-commitment-${c.title.toLowerCase().replace(/\s+/g, "-")}`}>
                <CheckCircle2 className="w-5 h-5 text-[#0d7a72] shrink-0 mt-0.5" />
                <div>
                  <h4 className="font-bold text-sm text-[#10233f]">{c.title}</h4>
                  <p className="text-sm text-[#5a6b85] leading-relaxed">{c.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
